<template>
  <div class="col-12">
    <ValidationObserver ref="facilitatorinquiryform" v-slot="{ handleSubmit }">
      <div
        class="row bg-light-gray border-radius--light row pl-3 pb-3 pr-3 pt-1 mr"
        style="border-radius: 5px 5px 0px 0px"
      >
        <div :class="getClassResponsive()">
          <datepicker
            v-model="model.dateReceived"
            label="Fecha en que se recibe:"
            format="dd/MMM./yyyy"
            :disabled="true"
          />
        </div>
        <div :class="getClassResponsive()">
          <ValidationProvider v-slot="{ errors }" rules="required">
            <datepicker
              v-model="model.dateAttended"
              label="Fecha en que se atiende:"
              format="dd/MMM./yyyy"
              :disabled="isReadOnly"
              :min-date="new Date(model.dateReceived)"
              :max-date="new Date()"
            />
            <small v-if="errors[0]" class="text-danger">
              <i class="fa fa-times-circle mr-2" />
              Fecha es requerida.
            </small>
          </ValidationProvider>
        </div>
        <div v-if="showAttendeeUser" :class="getClassResponsive()">
          <label class="input-label">Persona que atiende:</label>
          <div class="regular" v-text="model.personWhoAttends || '-'" />
        </div>
        <div :class="getClassResponsive()">
          <div class="d-flex offset-md-4  pt-4 ">
            <action-button
              variant="outline-danger m-1"
              :responsive="true"
              :i="`fas fa-times-circle`"
              @click="cancel"
            >
              Cancelar
            </action-button>
            <action-button
              variant="success m-1"
              :responsive="true"
              :i="`fas fa-${editting ? 'save' : 'file-plus'}`"
              :text="editting ? 'Guardar' : 'Añadir'"
              @click="handleSubmit(submit)"
            >
            </action-button>
          </div>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import Datepicker from "@/components/common/CustomDatePicker";
import ActionButton from "ActionButton";
const modelInitialState = () => ({
  dateReceived: null,
  dateAttended: null,
  personWhoAttends: null
});

export default {
  name: "FacilitatorInquiryForm",
  components: {
    Datepicker,
    ActionButton
  },
  props: {
    item: { type: Object, default: null },
    editting: { type: Boolean, default: false },
    isReadOnly: { type: Boolean, default: false },
    showAttendeeUser: { type: Boolean, default: true }
  },
  data: () => ({ model: modelInitialState() }),
  methods: {
    getClassResponsive() {
      return this.showAttendeeUser
        ? "col-12 col-sm-6 col-md-3 pt-2"
        : "col-12 col-sm-6 col-md-4 pt-2";
    },
    submit() {
      this.$emit("submit", this.model, this.cancel);
    },
    cancel() {
      this.model = modelInitialState();
      this.$refs["facilitatorinquiryform"].reset();
      this.$emit("cancel");
    }
  },
  created() {
    if (this.item) {
      this.model = { ...this.model, ...this.item };
    }
  }
};
</script>
